import { Component, NgZone } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import {Http, RequestOptions, Headers} from "@angular/http";
import {EbsWebService} from "../../services/ebsWebService";


@Component({
  selector: 'page-pdf-viewer',
  templateUrl: 'pdf-viewer.html'
})
export class PdfViewerPage {

  title: any;
  pageLoaded: boolean = false;
  pdfSrc: Uint8Array;

  constructor(public navCtrl: NavController, public navParams: NavParams, private http: Http, public ngZone: NgZone, public  _ebsWebService: EbsWebService) {
    this.title = navParams.get('title');


    let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(this.navParams.get('postParams'));
    this._ebsWebService.postData(this.navParams.get('actionURL'),postPayloadObject).subscribe(element=>{
        this.ngZone.run (() => {
          this.pdfSrc = element.DownloadURL;//new Uint8Array(file.arrayBuffer());
        });
    });

  }

  loaded() {
    this.pageLoaded = true;
  }
}



// WEBPACK FOOTER //
// ./src/pages/pdf-viewer/pdf-viewer.ts